import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {ManagedAccountsSearchCriteria} from '../typedef';
import type {CachedTableCacheSelector, CachedTableDataSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSearchResult} from 'src/openapi/admin/models/AccountSearchResult';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import type {GetManagedAccountIdsRequestFilters} from 'src/openapi/admin/models/GetManagedAccountIdsRequestFilters';


export const accountSearchResultSlice = getCachedTableDataSlice<
    AccountSearchResult[],
    ManagedAccountsSearchCriteria,
    AccountSortField,
    GetManagedAccountIdsRequestFilters & AccountSearchFiltering
>('assignedAccountsSearchResult');

export const accountSearchResultActions = accountSearchResultSlice.actions;
const accountSearchResultCacheSelector: CachedTableCacheSelector<AccountSearchResult[]>
    = state => state.userPage.tabs.assignedAccounts.result.cache;
export const accountSearchResultDataSelector: CachedTableDataSelector<AccountSearchResult[]>
    = state => state.userPage.tabs.assignedAccounts.result;
export const accountSearchResultResultSelector = getCachedTableResultSelector(
    accountSearchResultCacheSelector,
    accountSearchResultStateSelector,
);
